import georgianSpeechAi from '../../../images/articles/georgianSpeechAi.jpg'
import ragVsFineTuning from '../../../images/articles/ragVsFineTuning.jpg'
import aiTeamGeorgia from '../../../images/articles/aiTeamGeorgia.jpg'
import aiDevelopmentCost from '../../../images/articles/aiDevelopmentCost.jpg'
import aiProjectBrief from '../../../images/articles/aiProjectBrief.jpg'
import chatbotVsAgent from '../../../images/articles/chatbotVsAgent.jpg'
import measureAiAssistant from '../../../images/articles/measureAiAssistant.jpg'

// Cover images for data/articles.js, by the article's `cover` key.
export const articleCovers = { georgianSpeechAi, ragVsFineTuning, aiTeamGeorgia, aiDevelopmentCost, aiProjectBrief, chatbotVsAgent, measureAiAssistant }

const WORDS_PER_MINUTE = 200

// Site language → date locale (Georgian is 'ge' on the site, 'ka' in BCP 47).
const DATE_LOCALE = { en: 'en-GB', ge: 'ka-GE', ru: 'ru-RU', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', tr: 'tr-TR' }

const pick = (translations, key, fallback) => {
  const value = translations[key]
  return typeof value === 'string' && value.trim() ? value : fallback
}

// Swaps in translated text where the locale files have it ("art.<slug>.…").
export const localizeArticle = (article, translations) => {
  const t = (field, fallback) => pick(translations, `art.${article.slug}.${field}`, fallback)
  return {
    ...article,
    title: t('title', article.title),
    description: t('desc', article.description),
    sections: article.sections.map((section, i) => ({
      heading: section.heading ? t(`s.${i}.h`, section.heading) : section.heading,
      paragraphs: section.paragraphs.map((paragraph, j) => t(`s.${i}.p.${j}`, paragraph)),
    })),
  }
}

// "29 September 2026" and "5 MIN READ", in the active language.
export const articleMeta = (source, article, language, translations) => {
  const words = article.sections.reduce(
    (sum, section) => sum + section.paragraphs.join(' ').split(/\s+/).length + (section.heading ? section.heading.split(/\s+/).length : 0),
    0
  )
  const minutes = Math.max(1, Math.round(words / WORDS_PER_MINUTE))
  let date = source.date
  try {
    date = new Intl.DateTimeFormat(DATE_LOCALE[language] || 'en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(`${source.date}T12:00:00`))
  } catch (e) {
    // keep the ISO date
  }
  return { date, read: (translations.artMinRead || '{n} min read').replace('{n}', minutes) }
}
